import { PropsWithChildren, Children } from 'react';
import styled from 'styled-components';

type StepProps = StepContainerProps & {
  index: number;
};

type StepContainerProps = {
  currentStep: number;
};

const StepItem = styled.div<StepProps>`
  display: 'inline';
`;

const StepContainer = (props: PropsWithChildren<StepContainerProps>) => (
  <>
    {props.children &&
      Children.map(props.children, (child, index) => (
        <StepItem currentStep={props.currentStep} index={index}>
          {child}
        </StepItem>
      ))}
  </>
);

export default StepContainer;
